import styled from "styled-components";

export default styled.div`
  .nameMail-cont {
    .MuiTypography-root {
      display: block;
      width: 150px !important;
      white-space: nowrap;
      overflow: hidden;

      text-overflow: ellipsis;
    }
  }
`;
